import React from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
// import CommonHeaderRight from './CommonHeaderRight';
// import useDarkMode from '../../../hooks/useDarkMode';
// import Popovers from '../../../components/bootstrap/Popovers';
import Button from '../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { SubHeaderCenter } from '../../../layout/SubHeader/SubHeader';
import logo from '../../../assets/images/brand.png';
import { useNavigate } from 'react-router-dom';
import { useMst } from '../../../models'
import { removeItem } from '../../../lib/localstorage';

const DefaultHeader = () => {
	const deviceScreen = useDeviceScreen();
	const { t } = useTranslation(['translation', 'menu']);
	// const styledBtn = {
	// 	color: darkModeStatus ? 'dark' : 'light',
	// 	hoverShadow: 'default',
	// 	isLight: !darkModeStatus,
	// 	size: 'lg',
	// };
	// const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const navigate = useNavigate();
	const { user, config } = useMst()
	const isSelected = (menu) => {
		return location.pathname === menu ? 'selected-topmenu' : 'topmenu'
	}

	return (
		<Header className='trasparent'>
			<SubHeaderCenter>
				<div className='row g-3 text-center topmenu-container'>
					<div className='col-auto'>
						<Button  onClick={() => {navigate('/')}}>
							<img className='thumbnail' src={logo} alt='지음과 깃듬' />
						</Button>
					</div>
					<div className='col-auto'>
						<Button className={isSelected('/home')}
							onClick={() => navigate('/home')}
						>
							Home
						</Button>
					</div>
					<div className='col-auto'>
						<Button className={isSelected('/icru')}
							onClick={() => navigate('/icru')}
						>
							ICRU기질진단
						</Button>
					</div>
					<div className='col-auto'>
						<Button className={isSelected('/test')}
							onClick={() => navigate('/test')}
							// onClick={() => location.href = 'https://jng.icru.co.kr/test?code=dece95'}
						>
							진단하기
						</Button>
					</div>
					<div className='col-auto'>
						{!user?.id &&
						<Button className='topmenu'
							onClick={() => {
								config.setPrevPage('/')
								navigate('/login')
							}}
						>
							로그인
						</Button>}
						{user?.id > 0 &&
						<Button className='topmenu'
						shadow={'lg'}
						isLink={true}
							color="success"
							onClick={() => {
								// navigate('/mypage')
							}}
						>
							{user.name}
						</Button>}
					</div>
					<div className='col-auto'>
						{!user?.id &&
						<Button className='topmenu'
							onClick={() => navigate('/signup')}
						>
							회원가입
						</Button>}
						{user?.id > 0 &&
							<Button className='topmenu'
								onClick={() => {
									removeItem('access-token')
									removeItem('refresh-token')
									user.logout()
									navigate('/')
								}}
							>
								로그아웃
						</Button>}
					</div>
				</div>
			</SubHeaderCenter>
			{/* <CommonHeaderRight /> */}
		</Header>
	);
};

export default DefaultHeader;
